import React from 'react';
import { toast } from 'sonner';
import DefaultAssessmentResetDialog from '@/Pages/Candidates/components/dialogs/AssessmentResetDialog/AssessmentResetDialog';
import { DialogEnum, useActionDialogContext } from './Context/ActionDialogContext';
import { useCandidatesClient } from '@/Hooks/ClientHooks';
import UIStrings from '@/Utils/UIStrings';

const TableAssessmentResetDialog = () => {
    const candidatesClient = useCandidatesClient();
    const { isDialogOpen, hideDialog, selectedCandidates } = useActionDialogContext();

    const handleConfirm = async () => {
        if (selectedCandidates[0]) {
            const { assessmentId, candidateId, candidateFirstName } = selectedCandidates[0];
            try {
                await candidatesClient.resetApplicantAssessmentResultAsync(assessmentId, candidateId);
                toast.success(UIStrings.successAssessmentResetToast(candidateFirstName));
            } catch {
                toast.error(UIStrings.errorAssessmentResetToast(candidateFirstName));
            }
        }
    };

    return (
        <DefaultAssessmentResetDialog
            open={isDialogOpen(DialogEnum.ResetAssessment)}
            setOpen={() => hideDialog(DialogEnum.ResetAssessment)}
            onConfirm={handleConfirm}
        />
    );
};

export default TableAssessmentResetDialog;
